/* MYMALDO Black Month - theme.js */
(function () {
  'use strict';
  var T = window.theme || {};

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || T.moneyFormat || '€{{amount_with_comma_separator}}';
    function fmt(n, decimals, thousands, dec) {
      var num = (n / 100).toFixed(decimals);
      var parts = num.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, '.', ',');
      }
    });
  }
  T.formatMoney = formatMoney;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function initCountdowns() {
    var els = document.querySelectorAll('[data-countdown]');
    if (!els.length) return;
    function tick() {
      els.forEach(function (el) {
        var end = Date.parse(el.getAttribute('data-end'));
        if (isNaN(end)) return;
        var diff = end - Date.now();
        if (diff <= 0) { el.hidden = true; return; }
        el.hidden = false;
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        var map = { d: el.hasAttribute('data-inline') ? d : pad(d), h: pad(h), m: pad(m), s: pad(s) };
        Object.keys(map).forEach(function (k) {
          var t = el.querySelector('[data-cd="' + k + '"]');
          if (t) t.textContent = map[k];
        });
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
    return d;
  }
  function initDelivery() {
    document.querySelectorAll('[data-delivery]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 2, max = parseInt(el.dataset.max, 10) || 4;
      var opts = { weekday: 'short', day: '2-digit', month: '2-digit' };
      var a = addBusinessDays(new Date(), min).toLocaleDateString('de-DE', opts);
      var b = addBusinessDays(new Date(), max).toLocaleDateString('de-DE', opts);
      var t = el.querySelector('[data-delivery-range]');
      if (t) t.textContent = a + ' – ' + b;
    });
  }

  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var track = g.querySelector('[data-gallery-track]');
      if (!track) return;
      var thumbs = g.querySelectorAll('[data-gallery-thumbs] button');
      function slideW() { var s = track.children[0]; return s ? s.getBoundingClientRect().width + 8 : track.clientWidth; }
      function go(i) {
        var n = track.children.length; if (!n) return;
        i = (i + n) % n;
        track.scrollTo({ left: track.children[i].offsetLeft - track.children[0].offsetLeft, behavior: 'smooth' });
      }
      function current() { return Math.round(track.scrollLeft / Math.max(slideW(), 1)); }
      thumbs.forEach(function (b) { b.addEventListener('click', function () { go(parseInt(b.dataset.index, 10)); }); });
      var prev = g.querySelector('[data-gallery-prev]'), next = g.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var c = current();
          thumbs.forEach(function (b, i) { b.classList.toggle('is-active', i === c); });
        });
      });
    });
  }

  function initOffers() {
    document.querySelectorAll('[data-offer]').forEach(function (sec) {
      var jsonEl = sec.querySelector('[data-product-json]');
      if (!jsonEl) return;
      var product; try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var form = sec.querySelector('form.offer__form');
      if (!form) return;
      var idInput = form.querySelector('[data-variant-id]');
      var qtyInput = form.querySelector('[data-qty-input]');
      var variantSelect = form.querySelector('[data-variant-select]');
      var atc = form.querySelector('[data-atc]');
      var atcPrice = form.querySelector('[data-atc-price]');
      var atcText = form.querySelector('[data-atc-text]');
      var errorEl = form.querySelector('[data-atc-error]');
      var tierInputs = form.querySelectorAll('[data-tier] input[type="radio"]');
      var sticky = sec.querySelector('[data-sticky-atc]');
      var defaultLabel = atcText ? atcText.textContent : '';

      var setParam = new URLSearchParams(location.search).get('set');
      if (setParam) {
        tierInputs.forEach(function (inp) { if (inp.value === setParam) inp.checked = true; });
      }

      function variant() {
        var id = parseInt(idInput.value, 10);
        return product.variants.find(function (v) { return v.id === id; }) || product.variants[0];
      }
      function selectedTier() {
        var t = null;
        tierInputs.forEach(function (inp) { if (inp.checked) t = inp; });
        return t;
      }
      function calc(v, qty, disc) {
        var base = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
        var strike = base * qty;
        var final = Math.floor(v.price * qty * (100 - disc) / 100);
        return { strike: strike, final: final, each: Math.floor(final / qty), save: strike > final ? Math.floor((strike - final) * 100 / strike) : 0 };
      }
      function update() {
        var v = variant();
        tierInputs.forEach(function (inp) {
          var label = inp.closest('[data-tier]');
          label.classList.toggle('is-active', inp.checked);
          if (inp.dataset.variant) return;
          var r = calc(v, parseInt(inp.dataset.qty, 10) || 1, parseInt(inp.dataset.discount, 10) || 0);
          var p = label.querySelector('[data-tier-price]'); if (p) p.textContent = formatMoney(r.final);
          var s = label.querySelector('[data-tier-strike]'); if (s) s.textContent = formatMoney(r.strike);
          var e = label.querySelector('[data-tier-each]'); if (e) e.textContent = formatMoney(r.each);
          var sv = label.querySelector('[data-tier-save]'); if (sv) sv.textContent = '-' + r.save + ' %';
        });
        var t = selectedTier();
        var qty = t ? (parseInt(t.dataset.qty, 10) || 1) : 1;
        var disc = t ? (parseInt(t.dataset.discount, 10) || 0) : 0;
        var r = calc(v, qty, disc);
        if (t && t.dataset.variant) {
          idInput.value = t.dataset.variant;
          v = variant();
          qty = 1;
          var vp = parseInt(t.dataset.price, 10) || v.price;
          r = { strike: 0, final: vp, each: vp, save: 0 };
        }
        var addonSum = 0;
        form.querySelectorAll('[data-addon]').forEach(function (a) {
          a.closest('.addon').classList.toggle('is-checked', a.checked);
          if (a.checked) addonSum += parseInt(a.dataset.price, 10) || 0;
        });
        r.final += addonSum; if (r.strike) r.strike += addonSum;
        qtyInput.value = qty;
        if (atcPrice) atcPrice.innerHTML = r.strike > r.final ? '<s>' + formatMoney(r.strike) + '</s> ' + formatMoney(r.final) : formatMoney(r.final);
        if (atc) {
          atc.disabled = !v.available;
          if (atcText) atcText.textContent = v.available ? defaultLabel : T.strings.soldOut;
        }
        if (sticky) {
          var sp = sticky.querySelector('[data-sticky-price]'); if (sp) sp.textContent = formatMoney(r.final);
          var sl = sticky.querySelector('[data-sticky-label]'); if (sl) sl.textContent = t ? t.dataset.label : '';
        }
      }

      tierInputs.forEach(function (inp) { inp.addEventListener('change', update); });
      form.querySelectorAll('[data-addon]').forEach(function (a) { a.addEventListener('change', update); });
      document.querySelectorAll('[data-select-tier]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          var val = btn.getAttribute('data-select-tier');
          var target = null;
          tierInputs.forEach(function (inp) { if (inp.value === val) target = inp; });
          if (!target) return;
          e.preventDefault();
          target.checked = true; update();
          var box = form.querySelector('[data-tiers]') || sec;
          window.scrollTo({ top: box.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
        });
      });
      if (variantSelect) variantSelect.addEventListener('change', function () { idInput.value = variantSelect.value; update(); });
      update();

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var t = selectedTier();
        var qty = parseInt(qtyInput.value, 10) || 1;
        var items = [{ id: parseInt(idInput.value, 10), quantity: qty, properties: (t && !t.dataset.variant) ? { 'Paket': t.dataset.label } : {} }];
        if (t && t.dataset.gift) items.push({ id: parseInt(t.dataset.gift, 10), quantity: 1, properties: { 'Gratis-Geschenk': 'Ja' } });
        form.querySelectorAll('[data-addon]:checked').forEach(function (a) { items.push({ id: parseInt(a.dataset.variant, 10), quantity: 1 }); });
        if (atc) { atc.disabled = true; atc.classList.add('is-loading'); }
        if (errorEl) errorEl.hidden = true;
        fetch(T.routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          return res.json().then(function (data) { if (!res.ok) throw data; return data; });
        }).then(function () {
          return Cart.refresh().then(Cart.open);
        }).catch(function (err) {
          if (errorEl) { errorEl.textContent = (err && (err.description || err.message)) || 'Etwas ist schiefgelaufen. Bitte versuche es erneut.'; errorEl.hidden = false; }
        }).finally(function () {
          if (atc) { atc.disabled = !variant().available; atc.classList.remove('is-loading'); }
        });
      });

      if (sticky && atc) {
        var atcVisible = false, atcBelow = true;
        var updSticky = function () {
          var show = !atcVisible && window.scrollY > window.innerHeight * 0.6;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        };
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { atcVisible = en.isIntersecting; atcBelow = en.boundingClientRect.top > 0; updSticky(); });
          }).observe(atc);
        }
        window.addEventListener('scroll', updSticky, { passive: true });
        var sb = sticky.querySelector('[data-sticky-submit]');
        if (sb) sb.addEventListener('click', function (e) {
          e.preventDefault();
          if (atcBelow) {
            var target = form.querySelector('[data-tiers]') || sec;
            var top = target.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top: top, behavior: 'smooth' });
          } else if (form.requestSubmit) { form.requestSubmit(); } else { form.dispatchEvent(new Event('submit', { cancelable: true })); }
        });
      }
    });
  }

  var Cart = {
    el: null,
    open: function () {
      if (!Cart.el) return;
      Cart.el.classList.add('is-open');
      Cart.el.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    },
    close: function () {
      if (!Cart.el) return;
      Cart.el.classList.remove('is-open');
      Cart.el.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    },
    refresh: function () {
      return fetch(T.routes.cartJs, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(Cart.render);
    },
    change: function (line, qty) {
      var body = Cart.el.querySelector('[data-cart-lines]');
      body.classList.add('is-loading');
      return fetch(T.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(Cart.render).finally(function () { body.classList.remove('is-loading'); });
    },
    render: function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
      if (!Cart.el) return cart;
      var body = Cart.el.querySelector('[data-cart-lines]');
      var total = Cart.el.querySelector('[data-cart-total]');
      var ship = Cart.el.querySelector('[data-cart-shipping]');
      var checkout = Cart.el.querySelector('[data-checkout]');
      if (total) total.textContent = formatMoney(cart.total_price);
      if (checkout) checkout.hidden = cart.item_count === 0;
      if (ship) {
        var th = T.freeShippingCents || 0;
        if (th <= 0 || cart.total_price >= th) {
          ship.innerHTML = esc(T.strings.freeShippingReached) + '<div class="drawer__bar"><span style="width:100%"></span></div>';
        } else {
          var pct = Math.min(100, Math.round(cart.total_price * 100 / th));
          ship.innerHTML = esc(T.strings.freeShippingMissing).replace('[amount]', '<strong>' + formatMoney(th - cart.total_price) + '</strong>') + '<div class="drawer__bar"><span style="width:' + pct + '%"></span></div>';
        }
        ship.hidden = cart.item_count === 0;
      }
      if (!cart.items.length) { body.innerHTML = '<p class="drawer__empty">' + esc(T.strings.empty) + '</p>'; return cart; }
      body.innerHTML = cart.items.map(function (item, i) {
        var line = i + 1;
        var props = '';
        if (item.properties) {
          Object.keys(item.properties).forEach(function (k) {
            if (k.charAt(0) !== '_' && item.properties[k]) props += '<span class="muted">' + esc(k) + ': ' + esc(item.properties[k]) + '</span>';
          });
        }
        var discounts = (item.line_level_discount_allocations || []).map(function (d) {
          return '<span class="cart-line__disc">✓ ' + esc(d.discount_application.title) + ' (−' + formatMoney(d.amount) + ')</span>';
        }).join('');
        var img = item.image ? '<img class="cart-line__img" src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '<span class="cart-line__img"></span>';
        var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<span class="muted">' + esc(item.variant_title) + '</span>' : '';
        var strike = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
        return '<div class="cart-line">' + img +
          '<div class="cart-line__info"><a href="' + item.url + '"><strong>' + esc(item.product_title) + '</strong></a>' + variant + props + discounts +
          '<div class="qty"><button type="button" data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Weniger">−</button><span>' + item.quantity + '</span><button type="button" data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Mehr">+</button></div>' +
          '<button type="button" class="link-btn" data-line="' + line + '" data-qty="0">' + esc(T.strings.remove) + '</button></div>' +
          '<div class="cart-line__price">' + strike + '<strong>' + formatMoney(item.final_line_price) + '</strong></div></div>';
      }).join('');
      return cart;
    }
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function initCart() {
    Cart.el = document.querySelector('[data-cart-drawer]');
    if (!Cart.el) return;
    Cart.el.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', Cart.close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });
    Cart.el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]');
      if (b) Cart.change(parseInt(b.dataset.line, 10), Math.max(0, parseInt(b.dataset.qty, 10)));
    });
    document.querySelectorAll('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); Cart.refresh().then(Cart.open); });
    });
    Cart.refresh();
  }

  function initMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    menu.querySelectorAll('[data-close-menu]').forEach(function (a) { a.addEventListener('click', function () { menu.removeAttribute('open'); }); });
  }

  function initTicker() {
    document.querySelectorAll('[data-ticker]').forEach(function (t) {
      if (t.children.length < 1 || window.innerWidth > 749) return;
      Array.prototype.slice.call(t.children).forEach(function (c) { var cl = c.cloneNode(true); cl.setAttribute('aria-hidden', 'true'); t.appendChild(cl); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTicker();
    initCountdowns();
    initDelivery();
    initGalleries();
    initOffers();
    initCart();
    initMenu();
  });
})();
